module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/transferwise-db2cb33b9ff9ed9c8ad20d89c9729fb8.svg";